module.exports = __webpack_public_path__ + "media/images/icon_about2-236d06d17f548931402421146e664ae3.png";